import React from 'react'
import Board from './Board'
import Color from './Color'
import data from './data.js'

const FORMAT = 'format'

export default class BoardContainer extends React.Component {
  state={}
  componentDidMount() {
    const format = localStorage.getItem(FORMAT)
    if (typeof(format)==='string'&&format.length>0) {
      this.setState({format})
    } else {
      const {formats} = Color
      this.setState({format:formats[0]})
    }
  }
  onFormatChange=format=>{
    if (typeof(format)==='string'&&format.length>0) {
      this.setState({format},()=>{
        localStorage.setItem(FORMAT,format)
      })
    }
  }
  render() {
    const {format} = this.state
    const {slug} = this.props
    const {colors} = data
    if (typeof(slug)==='string'&&slug.length>0) {
      const value = colors.find(e=>e.slug===slug)
      if (typeof(value)==='object'&&value!==null) {
        return (
          <Board slug={slug} format={format} onChange={this.onFormatChange} />
        )
      }
    }
    return colors.map((e,i)=>(
      <Board key={i} slug={e.slug} format={format} onChange={this.onFormatChange} className="mb-5" />
    ))
  }
}
